import { Injectable } from '@angular/core';
import { GlobalConstants } from '../../common/constants/global.constant';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  constructor() {
  }

  sendGtag(eventName: string, eventParams: object) {
    const retailerId = sessionStorage.getItem('retailerId');
    const userId = sessionStorage.getItem('userId');
    const retailerName = sessionStorage.getItem('retailerName');
    const userRole = sessionStorage.getItem('userRole');
    const defaultValues = { event_name: eventName, retailer_name: retailerName, retailer_id: retailerId, ipos_user_id: userId,  user_role : userRole };
    if(eventName) {
     eventName =  eventName.split(' ').join('_');
    } 
    const updatedEventParams =  { ...eventParams, ...defaultValues };
    Object.keys(updatedEventParams).forEach(key => {
      if(updatedEventParams[key] && typeof updatedEventParams[key] == "string") {
        updatedEventParams[key] = updatedEventParams[key].split(' ').join('_');
      }
    })
    gtag(GlobalConstants.EVENT, eventName, updatedEventParams);
  }
  //IIT2-17363
  public packageIdleExperienceInformation(pkgData) {
    this.sendGtag(GlobalConstants.PACKAGE_IDLE_EXPERIENCE_INFORMATION, pkgData);
  }
  public createNewInstallationPackage(profileId:string, profileName: string) {
    this.sendGtag(GlobalConstants.PROFILE_INSTALLATION_PACKAGE_CLICK, { event_category: 'Profile Installation Package', event_label: 'Installation Pacakage', value: null, create_profile_with_package: 1, profile_id:profileId, profile_name:profileName });
  }
  public createNewProfileSuccess() {
    this.sendGtag(GlobalConstants.CREATE_NEW_PROFILE_SUCCESS, { event_category: 'Profile creation flow', event_label: 'Creation new profile successful', value: null, create_new_profile_succesful: 1 });
  }
  public updateProfileSuccess(profileId: string) {
    this.sendGtag(GlobalConstants.UPDATE_PROFILE_SUCCESS, { event_category: 'update Profile succesful', event_label: 'update profile successful', value: null, update_profile_succesful: profileId });
  }
  public updateViaCsv() {
    this.sendGtag(GlobalConstants.DEVICE_UPDATE_VIA_CSV, { event_category: GlobalConstants.DEVICE_UPDATE_VIA_CSV, event_label: GlobalConstants.DEVICE_UPDATE_VIA_CSV, value: null, update_via_csv: 1 });
  }
  public downloadGamingIpos() {
    this.sendGtag(GlobalConstants.DOWNLOAD_GAMING_IPOS, { event_category: 'Download standard', event_label: 'Download gaming IPOS', value: null, download_gaming_ipos: 1 });
  }
  public downloadLinuxIpos() {
    this.sendGtag(GlobalConstants.DOWNLOAD_LIBRARY_IPOS, { event_category: 'Download', event_label: 'Download Linux IPOS', value: null, download_linux_ipos: 1 });
  }
  public downloadStandardIpos() {
    this.sendGtag(GlobalConstants.DOWNLOAD_STANDARD_IPOS, { event_category: 'Download', event_label: 'Download Standard IPOS', value: null, download_standard_ipos: 1 });
  }
  public downloadChromebookIpos() {
    this.sendGtag(GlobalConstants.DOWNLOAD_CHROMEBOOK_IPOS, { event_category: 'Download', event_label: 'Download Chromebook IPOS', value: null, download_chromebook_ipos: 1 });
  }
  public downloadCreatorIpos() {
    this.sendGtag(GlobalConstants.DOWNLOAD_CREATOR_IPOS, { event_category: 'Download', event_label: 'Download Creator IPOS', value: null, download_creator_ipos: 1 });
  }

  public downloadIpos(packageType: string, language: string) {
    this.sendGtag(GlobalConstants.IPOS_DOWNLOAD, {
      event_category: 'Download',
      event_label: GlobalConstants.IPOS_DOWNLOAD, value: null, metric4: 1, download_standard_ipos: packageType,
      package_language: language
    })
  }

  public login() {
    const userRole = sessionStorage.getItem('userRole');
    let params: any = {
      user_role : userRole
    }
    if(userRole == 'author') {
      const partnerId = sessionStorage.getItem('partnerID');
      const partnerName = sessionStorage.getItem('partnerName');
      params.partner_id = partnerId ? partnerId : '(unset)';
      params.partnerName = partnerName ? partnerName : '(unset)';  
    }
    if(sessionStorage.getItem('usedTwoFA')){
      params.used_two_fa = 1;
      params.otp_sent = localStorage.getItem('otpSent');
    }
      this.sendGtag(GlobalConstants.Logged_IN, {
        event_category: GlobalConstants.Logged_IN,
        event_label: GlobalConstants.Logged_IN, value: null, ...params
      });
      if( localStorage.getItem('otpSent')){
        localStorage.removeItem('otpSent');
      }    
  }

  public storeLogoAdded() {
    this.sendGtag(GlobalConstants.STORES_LOGO_ADDED, { event_category: 'Logo Uploaded Profile ', event_label: 'Logo Uploaded Profile', store_logo_added: 1 });
  }

  public assetLibraryStoreLogoAdded() {
    this.sendGtag(GlobalConstants.ASSET_STORE_LOGO_ADDED, { event_category: 'Logo Uploaded Asset ', event_label: 'Logo Uploaded Asset', logo_uploaded_asset: 1 });
  }

  public rejectPendingUser() {
    this.sendGtag(GlobalConstants.REJECT_PENDING_USER, {
      event_name: GlobalConstants.REJECT_PENDING_USER, event_category: 'User management', event_label: 'Reject pending user', value: null, reject_pending_user: 1,
    });
  }

  public approvePendingUser() {
    this.sendGtag(GlobalConstants.APPROVE_PENDING_USER, {
      event_category: 'User management', event_label: 'Approve pending user', value: null, approve_pending_user: 1
    });
  }

  public addNewRetailerHQ() {
    this.sendGtag(GlobalConstants.ADD_NEW_RETAILER_HQ, { event_category: 'User management', event_label: 'Add new retailer hq', value: null, add_new_retailer_hq: 1 });
  }

  public resetPaswordSuccessful() {
    this.sendGtag(GlobalConstants.RESET_PASSWORD_SUCCESSFUL, { event_category: 'Reset password successful', event_label: 'Reset password successful', value: null, reset_password_successful: 1 });
  }

  public newContentGroupCreated() {
    this.sendGtag(GlobalConstants.NEW_CONTENT_GROUP_CREATED, { event_category: 'New content group created', event_label: 'New content group created', value: null, new_content_group_added: 1 });
  }
  public newModelSkuInfoAdded(skuId:string) {
    this.sendGtag(GlobalConstants.NEW_MODEL_SKU_INFO_ADDED, { event_category: 'New model SKU info added', event_label: ' new model SKU info added', value: null, new_model_sku_info_added: 1 , sku_id: skuId });
  }

  public skuInfoEdited() {
    this.sendGtag(GlobalConstants.SKU_INFO_EDITED, { event_category: 'SKU info edited', event_label: 'SKU info edited', value: null, sku_edited: 1 });
  }

  public pushUpdateDevice(isMultipleDevice:boolean, metricValues: object) {
    let eventName : string;
    let metriks : object;
    if(isMultipleDevice) {
      eventName = 'Multiple Device Push Updates';
      metriks = {push_update_multiple_device: 1};
    } else {
      eventName =  'Single Device Push update';
      metriks = { push_update_single_device: 1};
    }
    this.sendGtag(eventName, { event_category: 'Push update', event_label: 'Push update device', value: null, ...metriks, ...metricValues });

  }
  public pushUpdateLogo() {
    this.sendGtag(GlobalConstants.PUSH_UPDATE_LOGO, { event_category: 'Push update', event_label: 'Push update logo', value: null, push_update_logo: 1 });
  }
  public pushUpdateIdle() {
    this.sendGtag(GlobalConstants.PUSH_UPDATE_IDLE, { event_category: 'Push update', event_label: 'Push update idle experience', value: null, push_update_idle_experience: 1 });
  }
  public downloadFullReport(reportType: string) {
    this.sendGtag(GlobalConstants.DOWNLOAD_FULL_REPORT, { event_category: GlobalConstants.DOWNLOAD_FULL_REPORT, event_label: reportType, value: null, download_full_report: 1 });
  }
  public devieInfoTabName(tabName: string) {
    this.sendGtag(GlobalConstants.DEVICE_INFO_TAB_NAME, { event_category: GlobalConstants.DEVICE_INFO_TAB_NAME, event_label: tabName, value: null, device_infor_tab_name: tabName });
  }
  public devieInfoChangesSaved(tabName: string) {
    this.sendGtag(GlobalConstants.DEVICE_INFO_CHANGES_SAVED, { event_category: 'Device Info Changes Saved', event_label: tabName, value: null, device_info_changes: tabName });
  }
  //Solved
  public profileIncreasePromoRotation() {
    this.sendGtag(GlobalConstants.INCREASED_PROMO_ROTATION, { event_category: 'Promo Rotation', event_label: 'Promo Rotation', value: null, profile_increase_prom_rotation: 1 });
  }

  public profileInfoLogoContentGroup() {
    this.sendGtag(GlobalConstants.LOGO_CONTENT_GROUP, { event_category: 'Idle experiece option', event_label: 'Idle experience option', value: null, fact_tag_rotation_logo_content_group: 1 });
  }
  public profileInfoSegmentContentGroup() {
    this.sendGtag(GlobalConstants.INCLUDE_SEGMENT_CONTENT, { event_category: 'Idle experiece option', event_label: 'Idle experience option', value: null, fact_tag_rotation_segment_content_group: 1  });
  }

  public profileIdleExperience(idleValue: string) {
    this.sendGtag(GlobalConstants.IDLE_EXPERIENCE, { event_category: 'Idle experiece option', event_label: 'Idle experience option', value: null, idle_experience_option_selected: idleValue});
  }

  public PackageTypeCreated(packageType: string) {
    this.sendGtag(GlobalConstants.PACKAGE_TYPE_CREATED, { event_category: 'Package type created', event_label: packageType, value: null, package_type: packageType });
  }
  // IIT2-5312
  public skucsvUpload(uploadedSkuCount:number, uploadedSku: Array<string>) {
    this.sendGtag(GlobalConstants.SKU_CSV_UPLOAD, { event_category: GlobalConstants.SKU_CSV_UPLOAD, event_label: GlobalConstants.SKU_CSV_UPLOADED, value: null, sku_csv_upload: 1, uploaded_sku_count: uploadedSkuCount, uploaded_sku: uploadedSku  });
  }
  public pushPasswordChanges(type: string) {
    this.sendGtag(GlobalConstants.PUSH_PASSWORD_CHANGES, { event_category: GlobalConstants.PUSH_PASSWORD_CHANGES, event_label: type, value: null, push_password_changes: type });
  }
  public operatingSystem(operatingSystem: string) {
    this.sendGtag(GlobalConstants.OS_TYPE, { event_category: GlobalConstants.OS_TYPE, event_label: operatingSystem, value: null, os_type: operatingSystem });
  }
  public accountLanguage(language: string) {
    this.sendGtag(GlobalConstants.ACCOUNT_LANGUAGE, {
      event_category: GlobalConstants.ACCOUNT_LANGUAGE, event_label: language, value: null, account_language: language,
    });
  }

  public attractLoopVideoSelected() {
    this.sendGtag(GlobalConstants.ATTRACT_LOOP_VIDEO_SELECTED, { event_category: 'Attract Loop Video Selected', event_label: 'Attract Loop Video Selected', attract_loop_video_selected: 1 })
  }
  // IIT2-5312
  public accountTransfer() {
    this.sendGtag(GlobalConstants.ACCOUNT_TRANSFER, { event_category: GlobalConstants.ACCOUNT_TRANSFER, event_label: GlobalConstants.ACCOUNT_TRANSFER, value: null, account_transfer: 1 });
  }
  public idleExperienceOption(idleDisplay: string) {
    this.sendGtag(GlobalConstants.IDLE_EXPERIENCE_OPTION, { event_category: GlobalConstants.IDLE_EXPERIENCE_OPTION, event_label: idleDisplay, value: null, idle_experience_option: 1 });
  }
  public increasedPromoRotation() {
    this.sendGtag(GlobalConstants.INCREASED_PROMO_ROTATION, { event_category: GlobalConstants.INCREASED_PROMO_ROTATION, event_label: GlobalConstants.INCREASED_PROMO_ROTATION, value: null, increase_promo_rotation: 1 });
  }
  public hQAccAssignedtoRegUserChanged() {
    this.sendGtag(GlobalConstants.HQ_ACC_ASSIGNED_TO_REG_USER_CHANGED, { event_category: GlobalConstants.HQ_ACC_ASSIGNED_TO_REG_USER_CHANGED, event_label: GlobalConstants.HQ_ACC_ASSIGNED_TO_REG_USER_CHANGED, value: null, hq_acc_assigned_to_reg_user_changed: 1 });
  }

  public customMainTileFlagEnabledByRetailer() {
    this.sendGtag(GlobalConstants.CUSTOM_MAIN_TILE_FLAG_ENABLED, { event_category: GlobalConstants.CUSTOM_MAIN_TILE_FLAG_ENABLED, event_label: GlobalConstants.CUSTOM_MAIN_TILE_FLAG_ENABLED, value: null, custom_main_tile_flag_enabled: 1 });
  }
  public customMainTileContentGroupAdded() {
    this.sendGtag(GlobalConstants.CUSTOM_MAIN_TILE_CONTENT_GROUP_ADDED, { event_category: GlobalConstants.CUSTOM_MAIN_TILE_CONTENT_GROUP_ADDED, event_label: GlobalConstants.CUSTOM_MAIN_TILE_CONTENT_GROUP_ADDED, value: null, custom_main_tile_content_group_added: 1 });
  }
  public SkuContentAddedInPackage() {
    this.sendGtag(GlobalConstants.SKU_CONTENT_ADDED_IN_PACKAGE, { event_category: GlobalConstants.SKU_CONTENT_ADDED_IN_PACKAGE, event_label: GlobalConstants.SKU_CONTENT_ADDED_IN_PACKAGE, value: null, sku_content_added_in_package: 1 });
  }
  public  is4kVideoEnabled() {
    this.sendGtag(GlobalConstants.ENABLED_4K_VIDEO, { event_category: GlobalConstants.ENABLED_4K_VIDEO, event_label: GlobalConstants.ENABLED_4K_VIDEO, value: null, enabled_4k_video: 1});
  }
  public storeDeletedByRatailHQ(stores: string) {
    this.sendGtag(GlobalConstants.STORE_DELETED_BY_RETAILHQ, { event_category: GlobalConstants.STORE_DELETED_BY_RETAILHQ, event_label: stores, value: null, store_deleted_by_retailhq: 1 });
  }
  public storeDeletedbyAdmin(stores: string) {
    this.sendGtag(GlobalConstants.STORE_DELETED_BY_ADMIN, { event_category: GlobalConstants.STORE_DELETED_BY_ADMIN, event_label: stores, value: null,  store_deleted_by_admin: 1 });
  }
  public gameIncludedToThePackage(gameName: string, profileId: string ,profileName: string) {
    this.sendGtag(GlobalConstants.GAME_INCLUDED_TO_THE_PACKAGE, { event_category: GlobalConstants.GAME_INCLUDED_TO_THE_PACKAGE, event_label: gameName, value: null, game_included_to_the_package: gameName, profile_id: profileId, profile_name: profileName });
  }
  public downloadPackageTracking(pkgInfo: string) {
    this.sendGtag(GlobalConstants.DOWNLOAD_PACKAGE_TRACKING, { event_category: GlobalConstants.DOWNLOAD_PACKAGE_TRACKING, event_label: pkgInfo, value: null, download_package_tracking: pkgInfo });
  }
  public enableUpdateIPOSOverTheAir(mode:string, value: string) {
    this.sendGtag(GlobalConstants.ENABLE_UPDATE_IPOS_OVERTHEAIR, { event_category: GlobalConstants.ENABLE_UPDATE_IPOS_OVERTHEAIR, event_label: GlobalConstants.ENABLE_UPDATE_IPOS_OVERTHEAIR, value: null, enable_update_ipos_over_the_air: value, ota_updated_mode: mode });
  }
  public checkTwoFA(mode:string, value: number) {
    this.sendGtag(GlobalConstants.TWO_FA_ENABLED, { event_category: GlobalConstants.TWO_FA_ENABLED, event_label: GlobalConstants.TWO_FA_ENABLED, value: null, two_fa_enabled: value, two_fa_mode: mode == "update"? "Two_FA_enabled_existing" : "Two_FA_enabled_new"});
  }

  public deleteStore(storeCount: number, storeId: string | Array<string>) {
    this.sendGtag(GlobalConstants.DELETE_STORES, { event_category: GlobalConstants.DELETE_STORES, event_label: GlobalConstants.DELETE_STORES, value: null, deleted_store_count: storeCount, deleted_store_id: storeId });
  }

  public bulkUploadStore(storeCount: number) {
    this.sendGtag(GlobalConstants.BULK_UPLOAD_STORES, { event_category: GlobalConstants.BULK_UPLOAD_STORES, event_label: GlobalConstants.BULK_UPLOAD_STORES, value: null, csv_uploaded_store_count: storeCount });
  }

  public profileSkuInformation(profileId: string, profileName: string, skuInformation:Array<string>) {
    this.sendGtag(GlobalConstants.SKUS, {event_category: GlobalConstants.SKU_IDS, event_label: GlobalConstants.SKUS, value: null, profile_id: profileId, profile_name: profileName, package_sku_ids: skuInformation, package_sku_count_during_instalation: skuInformation.length});
  }

  public profileDeviceWallPaper(profileId: string, profileName: string, wallPaperInformation: string) {
    this.sendGtag(GlobalConstants.DEVICE_WALLPAPER, {event_category: GlobalConstants.DEVICE_WALLPAPER, event_label: GlobalConstants.DEVICE_WALLPAPER, value: null, profile_id: profileId, profile_name: profileName, device_wallpaper_enabled: true, wallpaper_type: wallPaperInformation});
  }

  public otaDevice(deviceCount: number, profileId: string, profileName: string, isBlackout: boolean ) {
    this.sendGtag(GlobalConstants.PUSH_UPDATES_OTA, {event_category: GlobalConstants.PUSH_UPDATES_OTA, event_label: deviceCount, value: null, ota_selected_device_count: deviceCount, profile_id: profileId, profile_name: profileName, blackout_used: isBlackout});
  }

  public battleStationDevice( retailerName:string, isEnabled: boolean, mode: string ) {
    this.sendGtag(GlobalConstants.BATTLE_STATION_DEVICE, {event_category: GlobalConstants.PUSH_UPDATES_OTA, event_label: isEnabled, value: null,   battle_station_flag_enabled: isEnabled, battle_station_retailer_name: retailerName, battle_station_updated_mode: mode });
  }

}

